module.exports = __webpack_public_path__ + "img/search.8ac3cd6b.svg";